/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  ManagerLogicCommon,
  ManagerLogicCommonInterface,
} from "../../../contracts/manager/ManagerLogicCommon";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ManagerLogicCommonConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ManagerLogicCommonConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ManagerLogicCommon__factory extends ContractFactory {
  constructor(...args: ManagerLogicCommonConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ManagerLogicCommon> {
    return super.deploy(overrides || {}) as Promise<ManagerLogicCommon>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): ManagerLogicCommon {
    return super.attach(address) as ManagerLogicCommon;
  }
  override connect(signer: Signer): ManagerLogicCommon__factory {
    return super.connect(signer) as ManagerLogicCommon__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ManagerLogicCommonInterface {
    return new utils.Interface(_abi) as ManagerLogicCommonInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ManagerLogicCommon {
    return new Contract(address, _abi, signerOrProvider) as ManagerLogicCommon;
  }
}
